import { request } from '../core';
import { cloudFetchConfig } from '@/utils/util';
import { Method } from '../core/util';

class CollectMapApi {
  public async getVehiclePage(params: { pageSize: number; pageNum: number }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getVehiclePage'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async fuzzySearchVehicle(searchName: string) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/fuzzySearchVehicle'),
      method: Method.POST,
      body: { searchName },
    };
    return request(requestOptions);
  }

  public async getExplorationTaskList({
    vehicleName,
    pageNum,
    pageSize,
    stationId,
    taskName,
  }: {
    vehicleName?: string;
    pageNum: number;
    pageSize: number;
    stationId?: number | null;
    taskName?: string | null;
  }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getExplorationTaskList'),
      method: Method.POST,
      body: { vehicleName, pageNum, pageSize, stationId, taskName },
    };
    return request(requestOptions);
  }

  public async getExplorationTaskDetail(taskId: number) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getExplorationTaskDetail'),
      method: Method.POST,
      body: { taskId },
    };
    return request(requestOptions);
  }

  public async getNearbyMarks(params: { latitude: number; longitude: number }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getNearbyMarks'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async getRoute(params: { vehicleName: string; taskId: number }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getRoute'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async associateTask(params: {
    vehicleName: string;
    taskId: number;
    action: number; // 0:取消认领 1:认领
    cockpitNumber: string;
  }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/associateTask'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async finishCollection(params: {
    vehicleName: string;
    taskId: number | string;
    cockpitNumber: string;
  }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/finishCollection'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async switchMode(params: {
    cockpitNumber: string;
    vehicleName: string;
    action: number; // 0:关闭 1:开启
    operateTime: number;
  }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/switchMode'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async switchCollection(params: {
    cockpitNumber: string;
    vehicleName: string;
    taskId: number;
    action: number; // 0: 暂停 1: 开始
  }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/switchCollection'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async getVideoUrlList(params: { vehicleNameList: string[] }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getVideoUrlList'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }

  public async checkSolidifiedData(params: { vehicleName: string }) {
    return request({
      ...cloudFetchConfig('/monitor/web/cockpit/map/getSolidifiedTaskList'),
      method: Method.POST,
      body: params,
    });
  }
  public async cancelSolidifiedTask(params: { taskId: string }) {
    return request({
      ...cloudFetchConfig('/monitor/web/cockpit/map/cancelSolidifiedTask'),
      method: Method.POST,
      body: params,
    });
  }
  public async getFinishedRoute(params: {
    taskId: number | string;
    vehicleName: string;
  }) {
    return request({
      ...cloudFetchConfig('/monitor/web/cockpit/map/getFinishedRoute'),
      method: Method.POST,
      body: params,
    });
  }

  public async getUserStations() {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/map/getUserStation'),
      method: Method.POST,
    };
    return request(requestOptions);
  }

  public async getMapInfoByPosition(params: { latitude: number; longitude: number }) {
    const requestOptions: RequestOptions = {
      ...cloudFetchConfig('/monitor/web/cockpit/getMapInfoByPosition'),
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  }
}

export default CollectMapApi;
